// @ts-ignore
import { v4 as uuid } from 'uuid'
import { FilterRow } from 'core/table/interfaces/Filters'

export type SavedFilter = {
  column: string
  value: {
    operator: string
    operand: unknown
  }
}

export type TableSortByResponse = {
  sortOrder: string
}

export const filterRowsToSaved = (rows: FilterRow[]): SavedFilter[] =>
  rows.map(({ column, value }) => ({
    column,
    value,
  }))

export const savedFiltersToFilterRows = (saved: SavedFilter[]): FilterRow[] =>
  saved.map(({ column, value }) => ({
    id: uuid(),
    column,
    operator: value.operator,
    value,
  }))

export const sortByToSortOrder = (sortBy: { id: string; desc?: boolean }[]): string => {
  const [sort] = sortBy
  if (!sort?.id || sort.id.startsWith('@')) {
    return ''
  }
  return `"${sort.id}" ${sort.desc ? 'desc' : 'asc'}`
}

export const sortOrderToSortBy = (sortOrder: string): { id: string; desc: boolean }[] => {
  if (!sortOrder) {
    return []
  }

  const [columnPart, direction = 'asc'] = sortOrder.split(' ')
  const id = columnPart.replace(/^"|"$/g, '')

  if (!id || id.startsWith('@')) {
    return []
  }

  return [{ id, desc: direction.toLowerCase() === 'desc' }]
}
